import React from "react";
import { Tab, Image, Grid, Card, Popup } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import iconInitiativeNormal from '../../../../images/icons-team-dashboard/icon-initiatives-normal.svg'
import iconInitiativeActive from '../../../../images/icons-team-dashboard/icon-initiatives-active.svg'
import iconPlaybooksNormal from '../../../../images/icons-team-dashboard/icon-playbooks-normal.svg'
import iconPlaybooksActive from '../../../../images/icons-team-dashboard/icon-playbooks-active.svg'
import iconContentsNormal from '../../../../images/icons-team-dashboard/icon-contents-normal.svg'
import iconContentsActive from '../../../../images/icons-team-dashboard/icon-contents-active.svg'
import iconStreamNormal from '../../../../images/icons-team-dashboard/icon-stream-normal.svg'
import iconStreamActive from '../../../../images/icons-team-dashboard/icon-stream-active.svg'
import iconActivitiesNormal from '../../../../images/icons-team-dashboard/icon-activities-normal.svg'
import iconActivitiesActive from '../../../../images/icons-team-dashboard/icon-activities-active.svg'
import iconTeamsNormal from '../../../../images/icons-team-dashboard/icon-teams-normal.svg'
import iconTeamsActive from '../../../../images/icons-team-dashboard/icon-teams-active.svg'
import UserNameAndMemberDetails from "../drive/cards/UserNameAndMemberDetails";
import OrganizationRecentUpdates from "../drive/cards/OrganizationRecentUpdates";
import InitiativeCard from '../drive/cards/InitiativeCard';
import StreamingData from "../../home/Drive/Cards/StreamingData";
import PlaybookCard from '../drive/cards/PlaybookCard';
import ContentCard from './../drive/cards/ContentCard';
import UserTeamsList from "../drive/cards/UserTeamsList";
import UserAssignedInitiativeActivity from '../drive/cards/UserAssignedInitiativeActivity';
import NoDataToDisplay from "../../../common/NoDataToDisplay";
import BreadCrumbOrganization from "../drive/cards/BreadCrumbOrganization";
import EventDetailsNotFound from './../../home/Drive/Modal/EventDetailsNotFound';

class SubOrganizationUserDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = { activeIndex: 0 }

    }

    handleTabChangeForOrg = async (e, data) => {
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        await dispatch.organizationUnit.showResourecePane(null)
        this.setState({ activeIndex: data.activeIndex })
        if (data.activeIndex === 0) {

        }
        else if (data.activeIndex === 1) {
            await dispatch.organizationTab.setTeamsDataForUser([]);
            await dispatch.organizationTab.getSubTeamsForUserAsync({
                "accountId": this.props.match.params.accountId,
                "organizationId": this.props.match.params.workspaceId,
                "teamId": this.props.match.params.teamId,
                "userId": this.props.match.params.userId
            });
        }
        else if (data.activeIndex === 2) {
            await dispatch.lifeCycle.getAllPlaybooksByUserIdAndTeamId({
                "accountId": this.props.match.params.accountId,
                "organizationId": this.props.match.params.workspaceId,
                //"teamId": this.props.match.params.teamId,
                "userId": this.props.match.params.userId
            });


        }
        else if (data.activeIndex === 3) {
            await dispatch.content.getAllContentsByUserIdAndTeamId({
                "accountId": this.props.match.params.accountId,
                "organizationId": this.props.match.params.workspaceId,
                //"teamId": this.props.match.params.teamId,
                "userId": this.props.match.params.userId
            });


        }
        else if (data.activeIndex === 4) {
            await dispatch.initiatives.getAllInitiativeByUserIdAndTeamId({
                "accountId": this.props.match.params.accountId,
                "organizationId": this.props.match.params.workspaceId,
                "teamId": this.props.match.params.teamId,
                "userId": this.props.match.params.userId
            });
        }
        else if (data.activeIndex === 5) {
            let payload
            if (this.props.match.params.workspaceId === this.props.match.params.teamId) {
                payload = {
                    organizationId: this.props.match.params.workspaceId,
                    userId: this.props.match.params.userId
                };
            }
            else {
                payload = {
                    organizationId: this.props.match.params.workspaceId,
                    teamId: this.props.match.params.teamId,
                    userId: this.props.match.params.userId
                };
            }

            await dispatch.initiatives.getInitiativeActivitiesForMember(payload);
        }

    }

    handleTabChangeForTeam = async (e, data) => {
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        await dispatch.organizationUnit.showResourecePane(null)
        this.setState({ activeIndex: data.activeIndex })
        if (data.activeIndex === 0) {

        }
        else if (data.activeIndex === 1) {
            await dispatch.organizationTab.setTeamsDataForUser([]);
            await dispatch.organizationTab.getSubTeamsForUserAsync({
                "accountId": this.props.match.params.accountId,
                "organizationId": this.props.match.params.workspaceId,
                "teamId": this.props.match.params.teamId,
                "userId": this.props.match.params.userId
            });
        }
        else if (data.activeIndex === 2) {
            await dispatch.initiatives.getAllInitiativeByUserIdAndTeamId({
                "accountId": this.props.match.params.accountId,
                "organizationId": this.props.match.params.workspaceId,
                "teamId": this.props.match.params.teamId,
                "userId": this.props.match.params.userId
            });
        }
        else if (data.activeIndex === 3) {
            let payload
            if (this.props.match.params.workspaceId === this.props.match.params.teamId) {
                payload = {
                    organizationId: this.props.match.params.workspaceId,
                    userId: this.props.match.params.userId
                };
            }
            else {
                payload = {
                    organizationId: this.props.match.params.workspaceId,
                    teamId: this.props.match.params.teamId,
                    userId: this.props.match.params.userId
                };
            }

            await dispatch.initiatives.getInitiativeActivitiesForMember(payload);
        }

    }

    componentWillMount() {
        this.getStart();
    }
    async getStart() {
        dispatch.app.showToolbar(false)
        if (!this.props.userObj || this.props.userObj === null) {
            await dispatch.users.getUserById(this.props.match.params.userId);
        }
        let payL = {
            limit: 50,
            type: ['practices', 'initiatives', 'contents'],
            organizationId: this.props.match.params.workspaceId,
            teamId: this.props.match.params.teamId,
            userId: this.props.match.params.userId
        }
        dispatch.notifications.getEventStreamForUserIdAndTeamId(payL);
        dispatch.notifications.getRecentUpdatesForTeamIdAndUserId({
            limit: 20,
            organizationId: this.props.match.params.workspaceId,
            teamId: this.props.match.params.teamId,
            userId: this.props.match.params.userId
        });

    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.userId.toString() !== nextProps.match.params.userId.toString()) {
            this.setState({ activeIndex: 0 })
        }
    }

    render() {
        const { activeIndex } = this.state
        const panesForOrg = [
            {
                menuItem: {
                    key: 'Events', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 0 ? iconStreamActive : iconStreamNormal} style={{ height: "14px" }} />}
                            content='Events'
                        />
                },
                render: () =>
                    <Grid>
                        <Grid.Row className="pad_0">
                            <Grid.Column width={11} style={{ padding: "0 5px 0 0" }} >
                                <Card className="w_100">
                                    <Card.Content className="pad_0" >
                                        <StreamingData
                                            show="all"
                                            initiativeOwnerDetails={this.props.initiativeOwnerDetails}
                                            selectedAccount={this.props.selectedAccount}
                                            notificationsCount={this.props.notificationsCount}
                                            selectedOrganisation={this.props.selectedOrganisation}
                                            loaderEventData={this.props.loaderEventStreamForTeamIdAndUserId}
                                            eventStreamArray={this.props.eventStreamArrayForUserIdAndTeamId}
                                            eventPage="User"
                                            noEventDataFound={this.props.noEventDataFound}
                                        />
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                            <Grid.Column width={5} style={{ padding: "0 0 0 5px" }}>
                                <Card className="w_100">
                                    <Card.Header className="pad_10">Recent Updates</Card.Header>
                                    <Card.Content className="pad_0" >
                                        <OrganizationRecentUpdates
                                            eventPage="User"
                                            recentUpdates={this.props.recentUpdatesForTeamIdAndUserId}
                                            loaderRecentUpdates={this.props.loaderRecentUpdatesForTeamIdAndUserId}
                                        />
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>,
            },
            {
                menuItem: {
                    key: 'Teams', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 1 ? iconTeamsActive : iconTeamsNormal} style={{ height: "14px" }} />}
                            content='Teams'
                        />
                },
                render: () =>
                    this.props.userSuborganizationList && this.props.userSuborganizationList.length ?
                        <UserTeamsList
                            userSuborganizationList={this.props.userSuborganizationList}
                            selectedOrganisation={this.props.selectedOrganisation}
                            selectedAccount={this.props.selectedAccount}
                            userId={this.props.match.params.userId}
                            userObj={this.props.userObj}
                            userToDel={this.props.userToDel}
                            userDelModalOpen={this.props.userDelModalOpen}
                            history={this.props.history}
                        />
                        : <NoDataToDisplay />
            },
            {
                menuItem: {
                    key: 'Playbooks', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 2 ? iconPlaybooksActive : iconPlaybooksNormal} style={{ height: "14px" }} />}
                            content='Playbooks'
                        />
                },
                render: () => <Card.Group className="playbookCardsList" >
                    {this.props.allPlaybooksByUserIdAndTeamId &&
                        this.props.allPlaybooksByUserIdAndTeamId.length ?
                        this.props.allPlaybooksByUserIdAndTeamId.map(function (playbook, index) {
                            return (
                                <PlaybookCard
                                    key={index}
                                    selectedPlaybook={playbook}
                                    index={index}
                                    {...this.props}
                                />
                            );
                        }, this)
                        : <NoDataToDisplay />
                    }
                </Card.Group>,
            },
            {
                menuItem: {
                    key: 'Content', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 3 ? iconContentsActive : iconContentsNormal} style={{ height: "14px" }} />}
                            content='Content'
                        />
                },
                render: () => <Card.Group className="playbookCardsList" >
                    {this.props.allContentsByUserIdAndTeamId && this.props.allContentsByUserIdAndTeamId.data &&
                        this.props.allContentsByUserIdAndTeamId.data.length ?
                        this.props.allContentsByUserIdAndTeamId.data.map(function (content, index) {
                            return (
                                <ContentCard
                                    key={index}
                                    selectedContent={content}
                                    index={index}
                                    {...this.props}
                                />
                            );
                        }, this)
                        : <NoDataToDisplay />
                    }
                </Card.Group>,
            },
            {
                menuItem: {
                    key: 'Initiatives', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 4 ? iconInitiativeActive : iconInitiativeNormal} style={{ height: "14px" }} />}
                            content='Initiatives'
                        />
                },
                render: () =>
                    <Card.Group className="playbookCardsList" >
                        {this.props.allInitiativesByUserIdAndTeamId && this.props.allInitiativesByUserIdAndTeamId.data &&
                            this.props.allInitiativesByUserIdAndTeamId.data.length ?
                            this.props.allInitiativesByUserIdAndTeamId.data.map(function (initiative, index) {
                                return (
                                    <InitiativeCard
                                        key={index}
                                        selectedInitiative={initiative}
                                        index={index}
                                        {...this.props}
                                    />
                                );
                            }, this)
                            : <NoDataToDisplay />
                        }
                    </Card.Group>,
            },
            {
                menuItem: {
                    key: 'Activities', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 5 ? iconActivitiesActive : iconActivitiesNormal} style={{ height: "14px" }} />}
                            content='Activities'
                        />
                },
                render: () =>
                    //  this.props.initiativeMemberActivities && this.props.initiativeMemberActivities.myActivities && this.props.initiativeMemberActivities.myActivities.length ?
                    <UserAssignedInitiativeActivity {...this.props} />
                // : <NoDataToDisplay />
            },


        ]

        const panesForTeam = [
            {
                menuItem: {
                    key: 'Events', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 0 ? iconStreamActive : iconStreamNormal} style={{ height: "14px" }} />}
                            content='Events'
                        />
                },
                render: () =>
                    <Grid>
                        <Grid.Row className="pad_0">
                            <Grid.Column width={11} style={{ padding: "0 5px 0 0" }} >
                                <Card className="w_100">
                                    <Card.Content className="pad_0" >
                                        <StreamingData
                                            show="all"
                                            initiativeOwnerDetails={this.props.initiativeOwnerDetails}
                                            selectedAccount={this.props.selectedAccount}
                                            notificationsCount={this.props.notificationsCount}
                                            selectedOrganisation={this.props.selectedOrganisation}
                                            loaderEventData={this.props.loaderEventStreamForTeamIdAndUserId}
                                            eventStreamArray={this.props.eventStreamArrayForUserIdAndTeamId}
                                            eventPage="User"
                                            noEventDataFound={this.props.noEventDataFound}
                                        />
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                            <Grid.Column width={5} style={{ padding: "0 0 0 5px" }}>
                                <Card className="w_100">
                                    <Card.Header className="pad_10">Recent Updates</Card.Header>
                                    <Card.Content className="pad_0" >
                                        <OrganizationRecentUpdates
                                            eventPage="User"
                                            recentUpdates={this.props.recentUpdatesForTeamIdAndUserId}
                                            loaderRecentUpdates={this.props.loaderRecentUpdatesForTeamIdAndUserId}
                                        />
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>,
            },
            {
                menuItem: {
                    key: 'Teams', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 1 ? iconTeamsActive : iconTeamsNormal} style={{ height: "14px" }} />}
                            content='Teams'
                        />
                },
                render: () =>
                    this.props.userSuborganizationList && this.props.userSuborganizationList.length ?
                        <UserTeamsList
                            userSuborganizationList={this.props.userSuborganizationList}
                            selectedOrganisation={this.props.selectedOrganisation}
                            selectedAccount={this.props.selectedAccount}
                            userId={this.props.match.params.userId}
                            userObj={this.props.userObj}
                            userToDel={this.props.userToDel}
                            userDelModalOpen={this.props.userDelModalOpen}
                            history={this.props.history}
                        />
                        : <NoDataToDisplay />
            },
            {
                menuItem: {
                    key: 'Initiatives', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 2 ? iconInitiativeActive : iconInitiativeNormal} style={{ height: "14px" }} />}
                            content='Initiatives'
                        />
                },
                render: () =>
                    <Card.Group className="playbookCardsList" >
                        {this.props.allInitiativesByUserIdAndTeamId && this.props.allInitiativesByUserIdAndTeamId.data &&
                            this.props.allInitiativesByUserIdAndTeamId.data.length ?
                            this.props.allInitiativesByUserIdAndTeamId.data.map(function (initiative, index) {
                                return (
                                    <InitiativeCard
                                        key={index}
                                        selectedInitiative={initiative}
                                        index={index}
                                        {...this.props}
                                    />
                                );
                            }, this)
                            : <NoDataToDisplay />
                        }
                    </Card.Group>,
            },
            {
                menuItem: {
                    key: 'Activities', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 3 ? iconActivitiesActive : iconActivitiesNormal} style={{ height: "14px" }} />}
                            content='Activities'
                        />
                },
                render: () =>
                    //this.props.initiativeMemberActivities && this.props.initiativeMemberActivities.myActivities && this.props.initiativeMemberActivities.myActivities.length ?
                    <UserAssignedInitiativeActivity {...this.props} />
                // : <NoDataToDisplay />
            },


        ]

        return (
            <div>
                <BreadCrumbOrganization {...this.props} />
                <UserNameAndMemberDetails {...this.props} />
                {this.props.match.params.workspaceId === this.props.match.params.teamId ?
                    <Tab

                        className="six-block tab-image-center teamDetailTab"
                        menu={{ secondary: true, pointing: true }}
                        panes={panesForOrg}
                        onTabChange={this.handleTabChangeForOrg}
                        activeIndex={this.state.activeIndex}
                    />
                    :
                    <Tab
                        className="four-block tab-image-center teamDetailTab"
                        menu={{ secondary: true, pointing: true }}
                        panes={panesForTeam}
                        onTabChange={this.handleTabChangeForTeam}
                        activeIndex={this.state.activeIndex}
                    />
                }

                <EventDetailsNotFound
                    open={this.props.noEventDataFound}
                />
            </div>
        );
    }
}
export default withRouter(SubOrganizationUserDetail);


